import { Link, useParams } from 'react-router-dom';
import numberWithCommas from '../utils/numberWithCommas';
import { formatTime } from '../../../../utils/get-event-start-time';
import { PATHNAMES } from "../../admin";

interface SessionListElementProps {
	sessionData: any
}

function SessionListElement({ sessionData }: SessionListElementProps): JSX.Element {

	const { tab, eventUuid }: { tab?: string, eventUuid?: string; } = useParams();

	return (
		<Link to={`${PATHNAMES.AnalyticsLink}/${tab}/${eventUuid}/${sessionData.uuid}`} style={{ textDecoration: 'none' }}>
			<div className="events-list-element" onClick={() => { console.log("Clicked"); }}>
				<div>
					<p className="events-list-element-label">{sessionData.timestamp ? formatTime(sessionData.timestamp) : ''}</p>
					<p className="events-list-element-value">{sessionData.title.base}</p>
				</div>
				<div>
					<p className="events-list-element-label"></p>
					<p className="events-list-element-value"></p>
				</div>
				<div>
					<p className="events-list-element-label">Registrations</p>
					<p className="events-list-element-value">{numberWithCommas(sessionData.registrations)}</p>
				</div>
				<div>
					<p className="events-list-element-label">Pageviews</p>
					<p className="events-list-element-value">{numberWithCommas(sessionData.pageviews)}</p>
				</div>
				<div>
					<p className="events-list-element-label status">Type</p>
					<p className={`events-list-element-value status Published`}>{sessionData.session_type}</p>
				</div>
			</div>
		</Link>
	);
}

export default SessionListElement;
